module.exports = __webpack_public_path__ + "img/bg.3bc198c3.jpg";